import React from "react";
import useActivitiesOfSector from "./useActivitiesOfSector";

const ActivitiesOfSector = ({
  secteur,
  onSelectActivity,
  selectedActivities = [],
}) => {
  // Trouver le secteur correspondant dans categories.json
  const { activitiesFiltered } = useActivitiesOfSector(secteur);
  return (
    <div
      className="list-group"
      style={{
        height: 300,
        overflowY: "auto",
      }}
    >
      {activitiesFiltered.map((activity) => {
        const isSelected = selectedActivities.includes(activity.id);

        return (
          <div
            key={activity.id}
            className="list-group-item list-group-item-action pl-5  d-flex align-items-center"
            onClick={() => onSelectActivity(activity.id)}
            style={{ cursor: "pointer" }}
          >
            <input
              type="checkbox"
              className="form-check-input mr-2"
              checked={isSelected}
              onChange={() => {}} // Géré par le onClick du parent
              // onClick={(e) => e.stopPropagation()}
            />
            <span>{activity.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ActivitiesOfSector;
